import { Column } from '@qtek/shared/models';

export const STATUS_MAP: Record<string, string> = {
  active: 'GNR_ACTIVE',
  todo: 'GNR_TODO',
  done: 'GNR_DONE',
  closed: 'GNR_CLOSED',
  broken: 'GNR_BROKEN',
  disabled: 'GNR_DISABLED',
  failed: 'GNR_FAILED',
  pending: 'GNR_PENDING',
} as const;

export const TASK_TABLE_COLUMNS: Column[] = [
  {
    id: 'action',
    label: 'GNR_TASK_TYPE',
    sortable: true,
    minWidth: 100,
    maxWidth: 100,
    hideOrder: 0,
    format: 'action',
    sticky: true,
  },
  {
    id: 'params.title',
    label: 'GNR_TITLE',
    sortable: false,
    minWidth: 250,
    maxWidth: 350,
    hideOrder: 1,
    sticky: true,
  },
  {
    id: 'status',
    label: 'GNR_STATUS',
    sortable: false,
    minWidth: 100,
    maxWidth: 150,
    hideOrder: 3,
    format: 'status',
  },
  {
    id: 'params.assignPrsUsr',
    label: 'GNR_ASSIGNEE',
    sortable: true,
    minWidth: 200,
    hideOrder: 4,
    format: 'assignee',
  },
  {
    id: 'executeDate',
    label: 'GNR_EXECUTE_DATE',
    sortable: true,
    minWidth: 140,
    maxWidth: 200,
    hideOrder: 5,
    format: 'date',
  },
  {
    id: 'params.authorFullName',
    label: 'GNR_AUTHOR',
    sortable: true,
    minWidth: 200,
    hideOrder: 6,
    format: 'usrId',
  },
  {
    id: 'params.dealName',
    label: 'GNR_DEAL',
    sortable: true,
    minWidth: 200,
    hideOrder: 7,
  },
  {
    id: 'params.note',
    label: 'GNR_ASSOCIATED_NOTE',
    sortable: false,
    minWidth: 200,
    hideOrder: 8,
    format: 'note',
  },
  {
    id: '_id',
    label: '',
    disableTranslate: true,
    minWidth: 48,
    maxWidth: 48,
    hideOrder: 9,
    stickyEnd: true,
  },
];
